import React from "react";
import { LuCoffee as Coffee } from "react-icons/lu";
import { SectionHeader } from "../section-header";
import { StatCard } from "../stat-card";
import { StatsByCategoryMap } from "../../types";
import { calcPercentage } from "../../utils/stats.util";

type Props = {
  stats: StatsByCategoryMap["LOUNGE"];
  expiry: number;
};

export const LoungeStatsSection: React.FC<Props> = ({ stats, expiry }) => {
  return (
    <div className="mb-8">
      <SectionHeader icon={Coffee} title="Lounge Requests Statistics" updateInfo={expiry} />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard icon={Coffee} title="Total Requests" value={stats.TOTAL_LOUNGE_REQUESTS.count} />
        <StatCard
          icon={Coffee}
          title="Requests (Last Month)"
          value={stats.LAST_MONTH_LOUNGE_REQUESTS.count}
          change={`${calcPercentage(
            stats.TOTAL_LOUNGE_REQUESTS.count,
            stats.LAST_MONTH_LOUNGE_REQUESTS.count
          )}% of Total`}
        />
        {/* <StatCard
          icon={Coffee}
          title="Active Requests"
          value="89"
          change="Pending approval"
          changeColor="text-yellow-600"
        />
        <StatCard icon={Coffee} title="Completed" value="3,234" change="93.6% approval rate" />
        <StatCard icon={Coffee} title="Expired" value="133" change="3.8% rejection rate" changeColor="text-red-600" /> */}
      </div>
    </div>
  );
};
